const PREF_EVENT = 'colors-pref-changed';
const PROFILE_KEY = 'avia_profile';

type ProfilePrefs = {
  id?: number;
  name?: string;
  login?: string;
  role?: string;
  color?: string | null;
  date_format?: 'dot' | 'long';
  hide_colors?: boolean;
};

const readProfile = (): ProfilePrefs => {
  try {
    return JSON.parse(sessionStorage.getItem(PROFILE_KEY) || '{}');
  } catch {
    return {};
  }
};

/** Профиль без токенов (для DateFormat / hide_colors вне React). */
export const syncProfilePrefs = (profile: ProfilePrefs | null) => {
  if (!profile) {
    sessionStorage.removeItem(PROFILE_KEY);
    // миграция со старого localStorage
    localStorage.removeItem('user');
  } else {
    const { id, name, login, role, color, date_format, hide_colors } = profile;
    sessionStorage.setItem(
      PROFILE_KEY,
      JSON.stringify({ id, name, login, role, color, date_format, hide_colors })
    );
    localStorage.removeItem('user');
  }
  window.dispatchEvent(new Event(PREF_EVENT));
};

export const getColorsHidden = (): boolean => Boolean(readProfile()?.hide_colors);

export const onColorsPrefChange = (handler: () => void) => {
  window.addEventListener(PREF_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(PREF_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
};
